/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the EmailMetricsResponse interface.
 */
export function instanceOfEmailMetricsResponse(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    if (!('fetchedAt' in value) || value['fetchedAt'] === undefined)
        return false;
    if (!('reason' in value) || value['reason'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function EmailMetricsResponseFromJSON(json) {
    return EmailMetricsResponseFromJSONTyped(json, false);
}
export function EmailMetricsResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'],
        'fetchedAt': json['fetched_at'],
        'reason': json['reason'],
        'status': json['status'],
    };
}
export function EmailMetricsResponseToJSON(json) {
    return EmailMetricsResponseToJSONTyped(json, false);
}
export function EmailMetricsResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'],
        'fetched_at': value['fetchedAt'],
        'reason': value['reason'],
        'status': value['status'],
    };
}
